define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('div', { 'className': this.getClass() }, this.getChildren());
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-body/table-body.rt
 ** module id = 189
 ** module chunks = 0
 **/